import React from 'react';
import { Hero } from '../components/Hero';
import { ServiceCard } from '../components/ServiceCard';
import { StatsBar } from '../components/StatsBar';
import { CTASection } from '../components/CTASection';
export function HomePage() {
  return <main className="flex-grow" data-id="element-243">
      <Hero data-id="element-244" />

      <section className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto pb-24" data-id="element-245">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-246">
          <ServiceCard label="Agency" title="Modern Commerce" tagline="Expert eCommerce Services" description="Full-service agency for Shopify, Commerce7 (Wine DTC), subscriptions and wine industry specialists." items={['Shopify', 'Subscriptions', 'Wine & DTC', 'Point of Sale', 'Support']} linkText="Learn More" linkTo="/modern-commerce" accentColor="primary" data-id="element-247" />

          <ServiceCard label="Software" title="Apps Division" tagline="Shopify Apps for Wine & DTC" description="Purpose-built applications for wineries and DTC brands. Launch partners for WinePik and Naiomi AI." items={['CorkShip eParcel (launching soon)', 'Personalization Engine (launching soon)', 'Wine Bundles (launching soon)', 'Wine Allocation (launching soon)', 'Loyalty (launching soon)']} linkText="View Apps" linkTo="/apps-division" accentColor="primary" data-id="element-248" />
        </div>
      </section>

      <StatsBar data-id="element-249" />

      <CTASection data-id="element-250" />
    </main>;
}